import { createReducer } from '@reduxjs/toolkit';

import setCreatePartTypeModalState from '../../actions/createPartTypeModal/createPartTypeModal';

const initialState = {
  visible: false,
};

const createPartTypeModalReducer = createReducer(initialState, {
  [setCreatePartTypeModalState]: (state, { payload }) => ({
    ...state,
    ...payload
  }),
});

export default createPartTypeModalReducer;
